module.exports = __webpack_public_path__ + "img/example02.5d950158.png";